import { type NavStore } from '@/types'
import { defineStore } from 'pinia'
import { useStoryblokApi } from '@storyblok/vue'

export const useNavStore = defineStore('NavStore', {
  state: (): NavStore => ({
    isDropdownMenuOpen: false,
    isMobile: false,
    lastScrollTop: 0,
    managedFooter: {}
  }),
  actions: {
    async fetchFooterContent() {
      const version = import.meta.env.VITE_OUTPUT_ENVIRONMENT !== 'production' ? 'draft' : 'published'
      const storyblokApi = useStoryblokApi()

      const FOOTER_PATH = 'cdn/stories/output-dot-com-content/global/footer/footer-content'

      const { data: footerResponse } = await storyblokApi.get(FOOTER_PATH, { version })

      if (!footerResponse?.story?.content) {
        return null
      }

      const { htmlTagline, menus, socialMediaLinks } = footerResponse.story.content

      this.managedFooter = {
        htmlTagline,
        menus,
        socialMediaLinks
      }
    },
    handleSideNavScroll(content: HTMLElement | null, sideNav: HTMLElement, selector: string) {
      // handles adding/removing class to sideNav when user scrolls to the end of page content
      // and then scrolls back to where content and sideNav are visible so fixed nav doesn't
      // overlap with footer content
      if (!content) {
        return
      }

      const menuHeight = 250
      const trackScrollTop = window.pageYOffset
      // offset the trigger for removing the fixed menu so it doesn't happen right at the end
      // of the content div to avoid div overlapping
      const offsetBounding = content.offsetTop - menuHeight
      const isScrollBelowContent = window.scrollY > offsetBounding + content.offsetHeight

      if (isScrollBelowContent) {
        sideNav.classList.add(selector)
      }

      const sideNavScrolled = document.querySelector(`.${selector}`)
      const isTopOfScrolledNav = sideNavScrolled && sideNavScrolled.getBoundingClientRect().top >= 0 && trackScrollTop < this.lastScrollTop

      if (isTopOfScrolledNav) {
        sideNav.classList.remove(selector)
      }
      this.lastScrollTop = trackScrollTop <= 0 ? 0 : trackScrollTop
    },
    offsetScrollTo(section: HTMLElement | null, offset: number): void {
      if (section) {
        window.scrollTo({
          behavior: 'smooth',
          top: section.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
        })
      }
    },
    toggleDropdownMenu() {
      this.isDropdownMenuOpen = !this.isDropdownMenuOpen
    },
    scrollToSection(event: MouseEvent): void {
      const target = event.target as HTMLElement
      const sectionId = target.innerText.toLowerCase().replace(/\s/g, '-')
      const section = document.getElementById(sectionId)
      const offSet = this.isMobile ? 80 : 95
      this.offsetScrollTo(section, offSet)
    }
  }
})
